'use es6';

import { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { getBackgroundColor, getBorderColor, getBorderRadius, getBorderWidth, getTextColor } from 'conversations-message-history/primary-message/operators/themeGetters';
import ThemeContext from 'conversations-message-history/primary-message/provider/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageContentWrapper = styled.div.attrs(() => ({
  'data-test-id': 'primary-message-content-wrapper'
})).withConfig({
  displayName: "PrimaryMessageContent__PrimaryMessageContentWrapper",
  componentId: "sc-1rd4qsr-0"
})(["position:relative;min-height:32px;width:100%;padding:0 12px;box-sizing:border-box;border-style:solid;border-width:", ";border-color:", ";background-color:", ";color:", ";display:flex;flex-direction:column;border-radius:", ";overflow:hidden;box-shadow:", ";"], ({
  borderWidth
}) => borderWidth, ({
  borderColor
}) => borderColor, ({
  backgroundColor
}) => backgroundColor, ({
  textColor
}) => textColor, ({
  borderRadius
}) => borderRadius, ({
  highlight
}) => highlight && `0 0 0 1px ${CALYPSO_MEDIUM}, 0 0 12px 0 ${CALYPSO_MEDIUM}`);
export const LegacyPrimaryMessageContentWrapper = styled.div.attrs(() => ({
  'data-test-id': 'primary-message-content-wrapper'
})).withConfig({
  displayName: "PrimaryMessageContent__LegacyPrimaryMessageContentWrapper",
  componentId: "sc-1rd4qsr-1"
})(["position:relative;min-height:32px;width:100%;box-sizing:border-box;border-style:solid;border-width:", ";border-color:", ";background-color:", ";color:", ";display:inline-flex;align-items:center;flex-direction:column;border-radius:", ";overflow:hidden;box-shadow:", ";"], ({
  borderWidth
}) => borderWidth, ({
  borderColor
}) => borderColor, ({
  backgroundColor
}) => backgroundColor, ({
  textColor
}) => textColor, ({
  borderRadius
}) => borderRadius, ({
  highlight
}) => highlight && `0 0 0 1px ${CALYPSO_MEDIUM}, 0 0 12px 0 ${CALYPSO_MEDIUM}`);
const PrimaryMessageContent = props => {
  const {
    children,
    className,
    highlight
  } = props;
  const theme = useContext(ThemeContext);
  return /*#__PURE__*/_jsx(PrimaryMessageContentWrapper, {
    className: className,
    backgroundColor: getBackgroundColor(theme),
    borderColor: highlight ? CALYPSO_MEDIUM : getBorderColor(theme),
    borderRadius: getBorderRadius(theme),
    borderWidth: highlight ? '1px' : getBorderWidth(theme),
    textColor: getTextColor(theme),
    highlight: highlight,
    theme: theme,
    children: children
  });
};
PrimaryMessageContent.displayName = 'PrimaryMessageContent';
PrimaryMessageContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  highlight: PropTypes.bool
};
export default PrimaryMessageContent;